var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMailGrey = function SvgMailGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.044,
    height: 20.048,
    viewBox: "0 0 20.044 20.048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-grey-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M0,15.7V4.344A4.335,4.335,0,0,1,4.344,0H15.7a4.335,4.335,0,0,1,4.344,4.344V15.7A4.335,4.335,0,0,1,15.7,20.048H4.344A4.346,4.346,0,0,1,0,15.7Z",
    fill: "#7c98b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M33.132,42.938a1.141,1.141,0,0,1-.56.149H19.121a1.089,1.089,0,0,1-.56-.149l4.483-4.483,1.1,1.1a2.283,2.283,0,0,0,1.7.635,2.312,2.312,0,0,0,1.7-.635l1.1-1.1Zm.392-.411L29.04,38.044l4.483-4.483a1.141,1.141,0,0,1,.149.56v7.846a.85.85,0,0,1-.149.56Zm-15.375,0a1.141,1.141,0,0,1-.149-.56V34.121a1.089,1.089,0,0,1,.149-.56l4.483,4.483Zm14.982-9.378-6,6a1.953,1.953,0,0,1-2.578,0l-6-6a1.141,1.141,0,0,1,.56-.149h13.45a1.141,1.141,0,0,1,.569.149Z",
    transform: "translate(-15.797 -28.004)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail-grey.b0d93ffc.svg";
export { ForwardRef as ReactComponent };